import { render, staticRenderFns } from "./DomainOppositionBasisForOppositionList.vue?vue&type=template&id=a658a7e8&"
import script from "./DomainOppositionBasisForOppositionList.vue?vue&type=script&lang=js&"
export * from "./DomainOppositionBasisForOppositionList.vue?vue&type=script&lang=js&"
import style0 from "./DomainOppositionBasisForOppositionList.vue?vue&type=style&index=0&id=a658a7e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports